import { Component } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';
import { FilterFieldComponent } from '../filter-field.component';
import { DatePickerFilterField } from './filter-field-date-picker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { getLocale } from '@vendasta/galaxy/utility/locale';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';

@Component({
  selector: 'va-filter-date-picker',
  template: `
    <EXP__glxy-wrap dense>
      <mat-form-field [appearance]="'outline'">
        <input
          matInput
          [matDatepicker]="picker"
          (click)="picker.open()"
          [value]="filterField.value"
          (dateChange)="dateChange($event)"
        />
        <mat-label>{{ '' + filterField.name | translate }}</mat-label>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </EXP__glxy-wrap>
  `,
  styles: [
    `
      :host {
        display: block;
        margin-bottom: -24px;
      }
    `,
  ],
  providers: [
    //for browsers with a negative GMT, the default datepicker would show the previous day
    { provide: MAT_DATE_LOCALE, useValue: getLocale() },
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
  ],
})
export class DatePickerFilterFieldComponent extends FilterFieldComponent<DatePickerFilterField> {
  dateChange(event: MatDatepickerInputEvent<moment.Moment>): void {
    this.applyFilter(event.value);
  }
}
